import { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { DialogShell } from '../ui/DialogShell';
import { ReleaseList } from './ReleaseList';
import { VersionHeatmap } from './VersionHeatmap';
import { versionService } from '../../services/versionService';

interface ChangelogModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly highlightVersionCode?: string;
}

export function ChangelogModal({ isOpen, onClose, highlightVersionCode }: ChangelogModalProps) {
  const [currentVersion, setCurrentVersion] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      versionService.getLatestVersionCode().then(code => setCurrentVersion(code)).catch(() => null);
    }
  }, [isOpen]);

  return (
    <DialogShell isOpen={isOpen} onClose={onClose} size="3xl" showCloseButton={false}>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h2 className="text-2xl font-bold text-gray-900">Historial de Versiones</h2>
          {currentVersion && (
            <div className="flex items-center gap-2 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg shadow-sm">
              <Sparkles className="w-4 h-4" />
              <span className="text-sm font-semibold">v{currentVersion}</span>
            </div>
          )}
        </div>
        <button
          onClick={onClose}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>
      </div>

      <VersionHeatmap />

      <div className="border-t border-gray-100 pt-4 -mx-1" />

      <div
        className="max-h-[calc(90vh-320px)] overflow-y-auto overflow-x-hidden px-4"
        style={{ overscrollBehavior: 'contain' }}
      >
        <ReleaseList highlightVersionCode={highlightVersionCode} />
      </div>
    </DialogShell>
  );
}
